import React, { useContext } from "react";
import "../../styles/app/WhatsAppBanner.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { ThemeContext } from "../../contexts/ThemeContext";

const WhatsAppBanner: React.FC = () => {
 const themeContext = useContext(ThemeContext);

  if (!themeContext) {
    throw new Error("ThemeContext must be used within a ThemeProvider");
  }

  const { isLightMode } = themeContext;

  return (
    <div className="whatsapp-banner" data-theme={isLightMode ? "light" : "dark"}>
      <a
        href="https://wa.me/17866589428"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="+1 (786) 658-9428"
      >
        <span className="whatsapp-icon">
          <FontAwesomeIcon icon={faWhatsapp} />
        </span>
        <span className="phone-number">+1 (786) 658-9428</span>
      </a>
    </div>
  );
};

export default WhatsAppBanner;
